<template>
  <div>
        <div class="img1">
            <a style="display:none"
                target="_blank"
                href="http://www.yzparking.cn:8083/gms/Login.d"
                class="animated fadeInDown"
            >登录</a>
        </div>
        <div class="img2"></div>
  </div>
</template>
<script>
export default {
  name: "parkservice",
  data() {
    return {};
  }
};
</script>

<style>
    .img1{
        background-size: 100% 100%;
        width: 100%;
        background-repeat: no-repeat;
        width: 100%;
        height: 500px;
        background-image: url('../assets/img/gov.png');
        text-align: center;
    }
    .img2{
        background-size: 100% 100%;
        width: 100%;
        background-repeat: no-repeat;
        width: 100%;
        height:800px;
        background-image: url('../assets/img/政府条页.png');
    }
    .img1 a {
        width: 120px;
        margin-bottom: 70px;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-color: #dcdfe6;
        color: #fff;
        background-color: #67c23a;
        border-color: #67c23a;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;

        font-size: 18px;
        border-radius: 25px;
        margin-bottom: 70px;
        margin-top: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/government.vue